import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { polyfill as seamlessScrollPolyfill } from 'seamless-scroll-polyfill';
import { CookieConsentComponent } from './components/cookieConsentComponent';
import { HamburgerButtonComponent } from './components/hamburgerButtonComponent';
import { ExpandButtonComponent } from './components/expandButtonComponent';
import { HeaderGapComponent } from './components/headerGapComponent';
import { FilterFormComponent } from './components/filterFormComponent';
import { ParallaxHelper } from './helpers/parallaxHelper';
import { OffsetHelperComponent } from './components/offsetHelperComponent';
import { ForwardClickComponent } from './components/forwardClickComponent';
import { StageVideoButtonComponent } from './components/stageVideoButtonComponent';
import { RevealHelper } from './helpers/revealHelper';
import { GoogleAnalyticsComponent } from './components/googleAnalyticsComponent';
import { ComponentSystem } from './componentSystem/componentSystem';
import { componentRegistration } from './componentRegistration';


seamlessScrollPolyfill();
const componentSystem = new ComponentSystem(componentRegistration);
componentSystem.init();

CookieConsentComponent.instance.init();
ExpandButtonComponent.instance.init();
HamburgerButtonComponent.instance.init();
HeaderGapComponent.instance.init();
FilterFormComponent.instance.init();
OffsetHelperComponent.instance.init();
ForwardClickComponent.instance.init();
StageVideoButtonComponent.instance.init();
GoogleAnalyticsComponent.instance.init();
ParallaxHelper.init();
RevealHelper.init();
